<script lang="ts" setup>
  import { useSessionStore } from "@/stores/session";
  import { MembershipStatus } from "@/models/membership";
  import Notice from "@/components/notices/Notice.vue";
  import router from "@/router";

  const sessionStore = useSessionStore();

  async function handleReviewPaymentClick() {
    await router.push({ name: 'renew' });
  }
</script>

<template>
  <notice
    v-if="sessionStore.membership?.status === MembershipStatus.OVERDUE"
    class="overdue-notice"
    icon="credit_card_gear"
    :text="$t('account.membership.subscription.overdue.text')"
    button-icon="arrow_forward"
    :button-text="$t('account.membership.subscription.overdue.btn')"
    background-color="error-400"
    color="white"
    @click="handleReviewPaymentClick"
  />
</template>

<style lang="scss" scoped>
</style>